import { assertResponse, getJson } from './Utils';

// User-selected pattern tags — the player's own reads on their moves and games ("panic", "never
// considered it"). Mirrors the backend UserTagsController. Move tags are keyed by move Pgn (the same
// bridge FavoritesAPI uses); the server resolves the MoveId. All writes require auth.

// One entry in the controlled vocabulary the pickers list.
export type TagVocabItem = {
  Slug: string;
  Label: string;
  Scope: 'Move' | 'Game';
  Category: string;
  Hint: string;
  Order: number;
};

// A user's current tags for one game: move tags keyed by move Pgn, plus whole-game tags.
export type GameTags = {
  MoveTags: Record<string, string[]>;
  GameTags: string[];
};

// A row of the per-user "your patterns" rollup.
export type UserPatternRow = {
  Theme: string;
  Scope: 'Move' | 'Game';
  GameCount: number;
  SampleGameIds: number[];
};

async function getVocabulary(): Promise<TagVocabItem[]> {
  const response = await fetch('/api/UserTags/vocabulary');
  return await getJson<TagVocabItem[]>(response);
}

async function getGameTags(gameId: number): Promise<GameTags> {
  const response = await fetch('/api/UserTags/game?gameId=' + gameId);
  return await getJson<GameTags>(response);
}

async function post(url: string): Promise<void> {
  const response = await fetch(url, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  await assertResponse(response);
}

function addMoveTag(gameId: number, pgn: string, theme: string): Promise<void> {
  return post(
    '/api/UserTags/move/add?gameId=' + gameId + '&pgn=' + encodeURIComponent(pgn) + '&theme=' + theme,
  );
}

function removeMoveTag(gameId: number, pgn: string, theme: string): Promise<void> {
  return post(
    '/api/UserTags/move/remove?gameId=' + gameId + '&pgn=' + encodeURIComponent(pgn) + '&theme=' + theme,
  );
}

function addGameTag(gameId: number, theme: string): Promise<void> {
  return post('/api/UserTags/game/add?gameId=' + gameId + '&theme=' + theme);
}

function removeGameTag(gameId: number, theme: string): Promise<void> {
  return post('/api/UserTags/game/remove?gameId=' + gameId + '&theme=' + theme);
}

async function getMyPatterns(): Promise<UserPatternRow[]> {
  const response = await fetch('/api/UserTags/patterns');
  return await getJson<UserPatternRow[]>(response);
}

export default {
  getVocabulary,
  getGameTags,
  addMoveTag,
  removeMoveTag,
  addGameTag,
  removeGameTag,
  getMyPatterns,
};
